// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GoogleOfflineOAuthCallbackQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  redirectUri: Types.Scalars['Url']['input'];
}>;

export type GoogleOfflineOAuthCallbackQuery = { __typename?: 'Query' } & Pick<
  Types.Query,
  'googleOfflineOAuthCallback'
>;

export const GoogleOfflineOAuthCallbackDocument = /*#__PURE__*/ gql`
    query GoogleOfflineOAuthCallback($code: String!, $redirectUri: Url!) {
  googleOfflineOAuthCallback(code: $code, redirectUri: $redirectUri)
}
    `;

/**
 * __useGoogleOfflineOAuthCallbackQuery__
 *
 * To run a query within a React component, call `useGoogleOfflineOAuthCallbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleOfflineOAuthCallbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleOfflineOAuthCallbackQuery({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useGoogleOfflineOAuthCallbackQuery(
  baseOptions: Apollo.QueryHookOptions<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables> &
    ({ variables: GoogleOfflineOAuthCallbackQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>(
    GoogleOfflineOAuthCallbackDocument,
    options,
  );
}
export function useGoogleOfflineOAuthCallbackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>(
    GoogleOfflineOAuthCallbackDocument,
    options,
  );
}
// @ts-expect-error
export function useGoogleOfflineOAuthCallbackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GoogleOfflineOAuthCallbackQuery,
    GoogleOfflineOAuthCallbackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>;
export function useGoogleOfflineOAuthCallbackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>,
): Apollo.UseSuspenseQueryResult<GoogleOfflineOAuthCallbackQuery | undefined, GoogleOfflineOAuthCallbackQueryVariables>;
export function useGoogleOfflineOAuthCallbackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GoogleOfflineOAuthCallbackQuery, GoogleOfflineOAuthCallbackQueryVariables>(
    GoogleOfflineOAuthCallbackDocument,
    options,
  );
}
export type GoogleOfflineOAuthCallbackQueryHookResult = ReturnType<typeof useGoogleOfflineOAuthCallbackQuery>;
export type GoogleOfflineOAuthCallbackLazyQueryHookResult = ReturnType<typeof useGoogleOfflineOAuthCallbackLazyQuery>;
export type GoogleOfflineOAuthCallbackSuspenseQueryHookResult = ReturnType<
  typeof useGoogleOfflineOAuthCallbackSuspenseQuery
>;
